import * as React from 'react';
import { Path } from 'react-native-svg';

function Meme() {
  return (
    <>
      <Path
        d="M68.5 119.77a7.2 7.2 0 01-.06 3.23 10.59 10.59 0 00.21 4.38 6.18 6.18 0 002.5 3.53 2.74 2.74 0 001.4.48 3.74 3.74 0 001.75-.57 5.23 5.23 0 002.27-1.82 5 5 0 00.51-1.62c.46-2.27.9-4.64.31-6.88"
        fill="#f9d9e6"
        stroke="#000"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.71}
      />
      <Path
        d="M44.08 105.37a7.58 7.58 0 001.75 7.72c3.07 3 7.86 2.49 12 3.5a7.67 7.67 0 013.33 1.58 4.09 4.09 0 011.43 3.37 5.55 5.55 0 014.39-2.07 23.73 23.73 0 014.95.64 32.64 32.64 0 006.69.45 10 10 0 005.48-1.44A4.69 4.69 0 0086 114"
        fill="none"
        stroke="#000"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.71}
      />
      <Path d="M72.5 122.73a13.73 13.73 0 01.3 2.72 5.31 5.31 0 01-.06 1.38 3.63 3.63 0 01-.56 1.28h-.05a5.43 5.43 0 01-.11-1.37 10 10 0 01.2-1.32 26 26 0 00.23-2.67l.05-.02z" />
      <Path
        d="M58.21 74.27C58.29 71.44 56 69 53.35 68c-2.29-.89-10.8-2.53-7.07 1.87 1 1.13 11.91 5.06 11.93 4.4zM81 74.81c-.09-2.84 2.22-5.3 4.86-6.33 2.28-.88 10.8-2.52 7.06 1.88C91.89 71.53 81 75.46 81 74.81z"
        stroke="#000"
        strokeMiterlimit={10}
      />
    </>
  );
}

export default Meme;
